import FiltersBar from './FiltersBar';

export default FiltersBar;



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/index.js